import React from 'react';
import { Link } from 'react-router-dom';

const Home = () => {
  return (
    <div className="home-page">
      {/* Hero Section */}
      <header className="hero-section">
        <div className="container-fluid">
          <div className="row">
            <div className="col-lg-8">
              <h5 className="text-accent text-uppercase letter-spacing-2 mb-3">Premier Offshore Solutions</h5>
              <h1 className="display-1 mb-4">Secure Your <br/>Legacy in Nevis</h1>
              <p className="lead mb-5">
                Expert guidance in Citizenship by Investment, LLC formation, Trust registration, and Asset Protection in one of the world's most secure jurisdictions.
              </p>
              <div className="d-flex gap-3">
                 <Link to="/contact" className="btn btn-accent px-5">Start Consultation</Link>
                 <Link to="/services" className="btn btn-outline-light px-5" style={{borderRadius: 0, padding: '1rem', textTransform: 'uppercase', letterSpacing: '2px', fontSize: '0.8rem'}}>Explore Services</Link>
              </div>
            </div>
          </div>
        </div>
      </header>

      {/* Introduction */}
      <section className="py-5">
        <div className="container py-5">
          <div className="row align-items-center g-5">
            <div className="col-lg-6">
                 <div className="p-5 border border-secondary">
                    <h2 className="display-5 text-white mb-4" style={{fontFamily: 'var(--font-serif)'}}>World-Class Fiduciary Services</h2>
                    <p className="text-muted mb-4">
                      Nevis Trust Services Limited offers a comprehensive suite of corporate and wealth management solutions. We specialize in navigating the unique legislative advantages of the Nevis jurisdiction to provide maximum privacy and asset protection for our global clientele.
                    </p>
                    <Link to="/about" className="text-accent text-decoration-none text-uppercase letter-spacing-1">
                      Read More About Us <i className="bi bi-arrow-right ms-2"></i>
                    </Link>
                 </div>
            </div>
            <div className="col-lg-6">
              <div className="row g-4">
                <div className="col-md-6">
                  <div className="card h-100 p-4">
                    <div className="icon-box">
                       <i className="bi bi-briefcase fs-4"></i>
                    </div>
                    <h5 className="fw-bold text-white">Corporate Formation</h5>
                    <p className="small text-muted mt-2">Efficient setup of LLCs and IBCs tailored to your needs.</p>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="card h-100 p-4">
                     <div className="icon-box">
                       <i className="bi bi-bank fs-4"></i>
                    </div>
                    <h5 className="fw-bold text-white">Trust Management</h5>
                    <p className="small text-muted mt-2">Robust trust structures for generational wealth preservation.</p>
                  </div>
                </div>
                 <div className="col-md-6">
                  <div className="card h-100 p-4">
                     <div className="icon-box">
                       <i className="bi bi-shield-check fs-4"></i>
                    </div>
                    <h5 className="fw-bold text-white">Asset Protection</h5>
                    <p className="small text-muted mt-2">Legal structures designed to safeguard your interests.</p>
                  </div>
                </div>
                 <div className="col-md-6">
                  <div className="card h-100 p-4">
                     <div className="icon-box">
                       <i className="bi bi-passport fs-4"></i>
                    </div>
                    <h5 className="fw-bold text-white">Citizenship</h5>
                    <p className="small text-muted mt-2">Second citizenship via investment programs.</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home;
